import { BaseController } from "./BaseController";
import { CourseTemplate } from "../types/CourseTemplate";

export class CourseController extends BaseController<CourseTemplate> {
  constructor() {
    super("courseTemplates", "CourseControllerDBCounters");
  }
}
